<template>
  <Card class="searchcard">
    <Row :gutter="2">
      <Col span="3">
        <Select v-model="formData.typeid">
          <Option
            :value="item.id"
            :label="item.type_name"
            v-for="(item, index) in typeList"
            :key="index"
          ></Option>
        </Select>
      </Col>
      <Col span="4">
        <Treeselect
          v-model="formData.categoryid"
          :multiple="false"
          :options="categoryTree"
        />
      </Col>
      <Col span="2">
        <Select v-model="formData.brandid" placeholder="品牌">
          <Option
            :value="item.id"
            :label="item.brand_name"
            v-for="(item, index) in brandList"
            :key="index"
          ></Option>
        </Select>
      </Col>
      <Col span="2">
        <Select v-model="formData.feature" placeholder="推荐">
          <Option :value="1" label="精品"></Option>
          <Option :value="2" label="新品"></Option>
          <Option :value="3" label="热销"></Option>
        </Select>
      </Col>
      <Col span="3">
        <RadioGroup
          style="padding-top:6px"
          class="m-l-10"
          v-model="formData.is_on_sale"
        >
          <Radio :label="1">上架</Radio>
          <Radio :label="0">下架</Radio>
        </RadioGroup>
      </Col>
      <Col span="4">
        <Input v-model="formData.keywords" placeholder="查询关键字" />
      </Col>
      <Col span="2">
        <Select v-model="formData.status" placeholder="状态">
          <Option :value="0" label="有效"></Option>
          <Option :value="-1" label="无效"></Option>
          <Option :value="99" label="不限"></Option>
        </Select>
      </Col>
      <Col span="2">
        <Button class="btn btn-theme" @click="fn_submit_search">
          <i class="fa fa-search"></i> 查询
        </Button>
      </Col>
    </Row>
  </Card>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: { Treeselect },
  data() {
    return {
      formData: {
        typeid: 0,
        categoryid: 0,
        brandid: 0,
        feature: 99,
        is_on_sale: 99,
        keywords: "",
        page: 0,
        pageNum: 15,
        status: 0
      }
    };
  },
  mounted() {},
  methods: {
    fn_submit_search() {
      this.$emit("on-search", this.formData);
    }
  },
  props: ["categoryTree", "brandList", "typeList"]
};
</script>
